import { useSearchParams } from 'react-router-dom';
import { useState, useEffect } from 'react';
import * as yup from 'yup';
import { Button } from 'primereact/button';
import { Checkbox } from 'primereact/checkbox';
import { InputText } from 'primereact/inputtext';
import { Link } from 'react-router-dom';
import { Message } from 'primereact/message';
import { Password } from 'primereact/password';
import { Title } from 'components/Title';
import useApp from 'hooks/useApp';
import useAuth from 'hooks/useAuth';
import IntroSlider from "./IntroSlider";
import './IndexPage.css';

import usePostForm from 'hooks/usePostForm';
import axios from 'axios'; // IMPORTANT: Add this import
export default function IndexPage() {
    const [showIntro, setShowIntro] = useState(true);

		const auth = useAuth();
	const app = useApp();
	const [searchParams] = useSearchParams();
	const [pageReady, setPageReady] = useState(true);
	const [rememberUser, setRememberUser] = useState(false);
	const formUrl = "auth/login";
	const formData = {
		username: '',
		password: '',
	}
	const validationSchema = yup.object().shape({
		username: yup.string().required().label(`Username or Email`),
		password: yup.string().required().label(`Password`),
	});

     useEffect(() => {
  setShowIntro(true);

  const timer = setTimeout(() => {
    setShowIntro(false);
  }, 15000); // Close modal after 10 seconds

  return () => clearTimeout(timer);
}, []);


	function afterSubmit(loginData){
		if (loginData.token) {
			auth.login(loginData.token);
			const returnUrl = searchParams.get('redirect') || '/home';
			app.navigate(returnUrl);
		}
		else if(loginData.nextpage){
			app.navigate(loginData.nextpage);
		}
	}
	const form = {
		formUrl, formData, validationSchema, afterSubmit
	}
	const { loading, errorMsg, setErrorMsg, formik } = usePostForm(form);
  const [googleLoading, setGoogleLoading] = useState(false);
    const [googleError, setGoogleError] = useState(null);
    const [isRedirecting, setIsRedirecting] = useState(false);
 // Fix API URL - ensure no double slashes
    const API_BASE_URL = process.env.REACT_APP_API_URL ? process.env.REACT_APP_API_URL.replace(/\/$/, '') : 'http://localhost:8060';
    const GOOGLE_CLIENT_ID = process.env.REACT_APP_GOOGLE_CLIENT_ID;
    useEffect(() => {
        // Check if user is already logged in
        const checkAuth = async () => {
            try {
                const token = localStorage.getItem('token');
                if (token) {
                    const response = await axios.get(`${API_BASE_URL}/api/AuthGoogle/me`, { // Fixed endpoint
                        headers: {
                            'Authorization': `Bearer ${token}`
                        }
                    });
                    if (response.data) {
                        const returnUrl = searchParams.get('redirect') || '/home';
                        app.navigate(returnUrl);
                        return;
                    }
                }
            } catch (error) {
                console.log('Not authenticated');
            }
        };
        checkAuth();
        // Load Google Identity Services
        const script = document.createElement('script');
        script.src = 'https://accounts.google.com/gsi/client';
        script.async = true;
        script.defer = true;
        document.body.appendChild(script);
        script.onload = () => {
            if (window.google) {
                window.google.accounts.id.initialize({
                    client_id: GOOGLE_CLIENT_ID,
                    callback: handleGoogleResponse,
                    auto_select: false,
                    cancel_on_tap_outside: true
                });
                const buttonElement = document.getElementById('google-signin-button');
                if (buttonElement) {
                    window.google.accounts.id.renderButton(
                        buttonElement,
                        {
                            theme: 'outline',
                            size: 'large',
                            text: 'sign_in_with',
                            shape: 'rectangular',
                            width: 250
                        }
                    );
                }
            }
        };
        return () => {
            if (document.body.contains(script)) {
                document.body.removeChild(script);
            }
        };
    }, []);
    const handleGoogleResponse = async (response) => {
        if (isRedirecting) return;
        setGoogleLoading(true);
        setGoogleError(null);
        try {
            // Correct endpoint - matches your controller name AuthGoogleController
            const endpoint = `${API_BASE_URL}/api/AuthGoogle/google`;
            console.log('Sending request to:', endpoint);
            console.log('Google token received:', response.credential.substring(0, 50) + '...');
            const result = await axios.post(endpoint, {
                token: response.credential
            }, {
                withCredentials: true,
                headers: {
                    'Content-Type': 'application/json'
                }
            });
            console.log('Backend response:', result.data);
            if (result.data) {
                setIsRedirecting(true);
                // Store user data
                if (result.data.token) {
                    localStorage.setItem('token', result.data.token);
                    if (auth.login) {
                        auth.login(result.data.token);
                    }
                }
                // Store user info
                localStorage.setItem('user', JSON.stringify({
                    userId: result.data.userId,
                    email: result.data.email,
                    fullName: result.data.fullName,
                    isAdmin: result.data.isAdmin
                }));
                // Redirect to home
                const returnUrl = searchParams.get('redirect') || '/home';
                console.log('Redirecting to:', returnUrl);
                // Use setTimeout to ensure state updates
                setTimeout(() => {
                    app.navigate(returnUrl);
                }, 100);
            }
        } catch (error) {
            console.error('Google login failed:', error);
            console.error('Error response:', error.response?.data);
            console.error('Error status:', error.response?.status);
            let errorMessage = 'Google login failed. Please try again.';
            if (error.response?.data?.message) {
                errorMessage = error.response.data.message;
            } else if (error.response?.data?.error) {
                errorMessage = error.response.data.error;
            }
            setGoogleError(errorMessage);
            setIsRedirecting(false);
        } finally {
            setGoogleLoading(false);
        }
    };
	return (
		<main id="IndexPage" className="main-page">
<section className="page-section mb-3" >
    <div className="container-fluid">
        <div className="grid justify-content-center">
            <div className="col-12 sm:col-6 md:col-3 comp-grid" >
                <Title title="User Login"  headerClass="p-3 card " titleClass="text-xl font-bold text-primary" subTitleClass="text-500" iconClass="pi pi-user" avatarSize="large" avatarClass="bg-primary"   separator={false} />
                <div className="card my-3 " >
                    <div >
                        <form onSubmit={formik.handleSubmit}>
                            <div className="mb-2 p-input-icon-left w-full">
                                <i className="pi pi-user"></i>
                                <InputText name="username" id="username" label="Username / Email / Phone Number" placeholder="Username / Email / Phone Number" className="w-full" value={formik.values.username} onChange={formik.handleChange} required="required" type="text" />
                            </div>
                            <div className="mb-2 p-input-icon-left w-full">
                                <i className="pi pi-lock"></i>
                                <Password name="password" id="password" value={formik.values.password} onChange={formik.handleChange} label="Password" inputClassName="w-full" feedback={false} toggleMask className="w-full" placeholder="Password" required="required" />
                            </div>
                            <div className="flex justify-content-between align-items-center my-2">
                                <div className="field-checkbox">
                                    <Checkbox inputId="rememberme" checked={rememberUser} onChange={e => setRememberUser(e.checked)} />
                                    <label className="text-sm text-500" htmlFor="rememberme">Remember Me</label>
                                </div>
                                <div>
                                    <Link to="/forgotpassword" className="p-button p-button-danger p-button-text">Reset Password?</Link>
                                    </div>
                                </div>
                                { errorMsg && <Message text={errorMsg} severity="error" /> }
                                <div className="text-center">
                                    <Button label="Login"  loading={loading} icon="pi pi-lock-open" className="p-button-lg p-button-raised w-full"  type="submit"> 
                                    </Button>
                                </div>
                            </form>
                        </div>
                    </div>
                    <div className="">
                        {/* Divider */}
                        <div className="text-center my-2">
                            <div className="or-divider">
                                <span>OR</span>
                            </div>
                        </div>
                        {/* Google Login Button */}
                        <div className="flex justify-content-center w-full">
                            {googleLoading ? (
                            <Button 
                            label="Authenticating..." 
                            loading={true} 
                            className="p-button-outlined w-full"
                            style={{ maxWidth: '250px' }}
                            />
                            ) : (
                            <div 
                                id="google-signin-button" 
                                style={{ 
                                display: 'flex', 
                                justifyContent: 'center', 
                                width: '100%' 
                                }}
                            ></div>
                            )}
                        </div>
                        {googleError && (
                        <Message 
                        text={googleError} 
                        severity="error" 
                        className="mt-2" 
                        style={{ width: '100%' }}
                        />
                        )}
                        <style>{`
                        .or-divider {
                        position: relative;
                        text-align: center;
                        margin: 20px 0;
                        }
                        .or-divider::before,
                        .or-divider::after {
                        content: '';
                        position: absolute;
                        top: 50%;
                        width: 45%;
                        height: 1px;
                        background: #e0e0e0;
                        }
                        .or-divider::before {
                        left: 0;
                        }
                        .or-divider::after {
                        right: 0;
                        }
                        .or-divider span {
                        background: white;
                        padding: 0 10px;
                        color: #666;
                        font-size: 14px;
                        }
                        `}</style>
                    </div>
                    <div className="card  sp-2">
                        <div className="grid gap-3 align-items-center justify-content-between">
                            <div className="col text-500 font-bold text-sm">
                                Don't Have an Account?
                            </div>
                            <div className="col-fixed">
                                <Link to="/register">
                                    <Button icon="pi pi-user" label="Customer Registration" className="p-button-success" />
                                    </Link>
                                </div>
                            </div>
                        </div>
                        <Link to={`/partnerreister`}>
                            <Button label="Partner Registration" icon="pi pi-user-edit" type="button" className="p-button w-full bg-green-100 text-black-alpha-80 "  />
                            </Link>
                        </div>
                    </div>
                </div>
            </section>

               {/* Intro Modal */}
      {showIntro && (
        <div className="intro-modal-overlay">
          <div className="intro-modal">
            <button
              className="intro-close-btn"
              onClick={() => setShowIntro(false)}
            >
              &times;
            </button>

            <IntroSlider />
          </div>
        </div>
      )}


		</main>
	);
}
